<template>
  <div
    class="dropdown"
    @mouseenter="isMenuShow = true"
    @mouseleave="isMenuShow = false"
    :class="{ 'is-active': isMenuShow }"
  >
    <span class="dropdown__text">
      {{ text }}
      <i class="el-icon-arrow-down el-icon" :class="{ 'is-active': isMenuShow }"></i>
    </span>
    <div class="dropdown__menu" :class="{ 'is-active': isMenuShow }" v-show="isMenuShow">
      <slot name="menu"></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    text: String
  },
  data() {
    return {
      isMenuShow: false
    }
  }
}
</script>
<style lang="scss" scoped>
.dropdown {
  position: relative;
  padding: 15px;
  box-sizing: border-box;
  margin: 1px;

  &.is-active {
    margin: 0;
    border: 1px solid #ddd;
    border-bottom: none;
  }

  &.is-active &__text {
    color: $main-color;
  }
  &.is-focus &__text {
    color: $main-color;
  }
  &__text {
    cursor: pointer;
    line-height: 1;
    & .el-icon-arrow-down {
      font-size: 18px;
      transition: transform 0.2s;
      &.is-active {
        transform: rotate(180deg);
      }
    }
  }
  &__menu {
    position: absolute;
    box-sizing: border-box;
    z-index: 3000;
    top: 90%;
    left: 0;
    background-color: #fff;
    &.is-active {
      border: 1px solid #ddd;
      border-top: none;
      width: calc(100% + 2px);
      margin-left: -1px;
    }
  }
}
</style>
